const AUTH_EXPIRED_EVENT = 'auth-expired';

function handleUnauthorized() {
  localStorage.removeItem('auth_token');
  localStorage.removeItem('user');
  sessionStorage.setItem('auth_expired', '1');
  window.dispatchEvent(new Event(AUTH_EXPIRED_EVENT));
}

export async function apiFetch<T>(input: RequestInfo, init?: RequestInit): Promise<T> {
  const token = localStorage.getItem('auth_token');
  const isFormData = init?.body instanceof FormData;

  const headers: Record<string, string> = {
    ...(isFormData ? {} : { 'Content-Type': 'application/json' }),
    ...(init?.headers as Record<string, string> ?? {}),
  };

  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }

  const response = await fetch(input, {
    credentials: 'include',
    ...init,
    headers,
  });

  if (response.status === 401) {
    handleUnauthorized();
    throw new Error('Unauthorized');
  }

  if (!response.ok) {
    const text = await response.text();
    throw new Error(`API error ${response.status}: ${text}`);
  }

  return response.json() as Promise<T>;
}
